import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Errors} from 'react-redux-form';

class CustomError extends Component {
	render() {
		const {model, messages, translate, wrapper, component, ...rest} = this.props;
		let translatedMessages = {};

		if(messages[model]) {
			Object.entries(messages[model]).forEach(([key, value]) => {
				translatedMessages[key] = translate(value);
			});
		}

		return (
			<Errors
				model={`.${model}`}
				messages={translatedMessages}
				wrapper={wrapper}
				component={component}
				{...rest}
			/>
		)
	}
}

const errorWrapper = (props) =>  {
	return (
		<div className={props.wrapperClassName}>
			{
				props.children && props.children.length > 1
				? props.children[0]
				: props.children
			}
		</div>
	);
};

const errorComponent = (props) => {
	return (
		<span className="help-block">
			{props.children}
		</span>
	);
};

CustomError.defaultProps = {
	wrapperClassName: 'has-error',
	wrapper: errorWrapper,
	component: errorComponent
};

CustomError.propTypes = {
	model: PropTypes.string.isRequired,
	messages: PropTypes.object.isRequired,
	translate: PropTypes.func.isRequired,
	wrapperClassName: PropTypes.string,
	wrapper: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.func
	]),
	component: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.func
	])
};

export default CustomError;